var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.textToShow)?_c('div',{staticStyle:{"word-wrap":"break-word"}},[_c('v-icon',[_vm._v("mdi-information-variant")]),_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44cdf328","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/help/CustomText.vue
// module id = null
// module chunks = 